import { NavItem } from './NavItem';

export type { TypeNavItemProps } from './types';
export default NavItem;
